export interface SalesToolsConfig {
    isProd: boolean;
}

/** Defaults to prod (true) so devtools are never accidentally enabled in production. */
let _config: SalesToolsConfig = { isProd: true };

/** Call once from the harness (expert-ui, storybook) before any stores are imported. */
export function configureSalesTools(config: SalesToolsConfig): void {
    _config = config;
}

export function getIsProd(): boolean {
    return _config.isProd;
}
